import { render } from "./HelloView.vue?vue&type=template&id=04a198e8&scoped=true"
import script from "./HelloView.vue?vue&type=script&lang=js"
export * from "./HelloView.vue?vue&type=script&lang=js"

import "./HelloView.vue?vue&type=style&index=0&id=04a198e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a198e8"]])

export default __exports__